import React, { PureComponent } from "react"
import { getState } from "radium"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium"
import Highlighter from "react-highlight-words"
import { BASE_HEADING, BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"
import { Hyperlink } from "components"

class SearchResultItem extends PureComponent {
  render() {
    const {
      title, description, animationDelay, href, highlight, gtmEvents
    } = this.props
    return (
      <Hyperlink
        gtmEvents={gtmEvents}
        href={href}
        withoutStyle
        style={{ ...styles.container }}>
        {title && (
          <strong
            style={[
              styles.title,
              getState(this.state, "main", ":hover") && { textDecoration: "underline" }
            ]}>
            {title}
          </strong>
        )}
        {description && (
          <p style={styles.description}>
            <Highlighter
              highlightStyle={{ fontWeight: 400, backgroundColor: "transparent" }}
              searchWords={highlight || []}
              textToHighlight={description} />
          </p>
        )}
      </Hyperlink>
    )
  }
}

SearchResultItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  animationDelay: PropTypes.number,
  href: PropTypes.string,
  gtmEvents: PropTypes.array
}

export default Radium(SearchResultItem)

const fadeInKeyframes = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
})

const styles = {
  title: {
    ...BASE_HEADING
  },
  description: {
    ...BASE_COPY,
    textDecoration: "none"
  },
  container: {
    color: COLOR_PALETTE.BLACK,
    display: "block",
    textDecoration: "none",
    margin: "2em 0",
    paddingTop: "2em",
    borderTop: `1px solid ${COLOR_PALETTE.GRAY}`,
    ":hover": {}
  },
  animation: delay => ({
    opacity: 0,
    animation: `x .666s ${delay}s forwards`,
    animationName: fadeInKeyframes
  })
}



// WEBPACK FOOTER //
// ./src/containers/site-search/search-result-item.jsx